import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Redirect from './pages/Redirect';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/:tenantId/:entryPointCode/:skeleton" element={<Home />} />
        <Route path="/" element={<Redirect />} />
        <Route path="*" element={<Redirect />} />
      </Routes>
    </Layout>
  );
}

export default App;

